export default __webpack_public_path__ + "static/media/tires.97783082.svg";